import { render, staticRenderFns } from "./Phases.vue?vue&type=template&id=57b06a59&scoped=true&"
import script from "./Phases.vue?vue&type=script&lang=js&"
export * from "./Phases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b06a59",
  null
  
)

export default component.exports